// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".tagBox[data-v-6f22b84e]{margin-top:10px;min-height:100px}.tagBox .title[data-v-6f22b84e]{font-weight:500;font-size:16px}.tagBox .el-tag[data-v-6f22b84e]{margin:1px 3px}[data-v-6f22b84e] .el-dialog__body{overflow:auto!important}", ""]);
// Exports
module.exports = exports;
